import { render, staticRenderFns } from "./FlatRecordTable.vue?vue&type=template&id=464d1408&scoped=true"
import script from "./FlatRecordTable.vue?vue&type=script&lang=js"
export * from "./FlatRecordTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464d1408",
  null
  
)

export default component.exports